import {
  AiChatActionType,
  ChatMessageType,
  ChatSession,
  MessageActor,
  MessageType,
  ShipmentStatus
} from '@/features/AiChat/model/api/chat/types';

const getLastAgentMessage = (session: ChatSession): ChatMessageType | undefined => {
  return [...session.message_history].reverse().find((message) => {
    return message.actor === MessageActor.AGENT;
  });
};

const getPendingProposalMessage = (session: ChatSession | null): ChatMessageType | undefined => {
  if (
    !session
    || [ShipmentStatus.CANCELLED, ShipmentStatus.DONE].includes(session.shipment_status)
  ) {
    return undefined;
  }

  const lastAgentMessage = getLastAgentMessage(session);

  if (
    lastAgentMessage?.response_type === MessageType.WIDGET_PROPOSAL
    && lastAgentMessage.actions?.includes(AiChatActionType.ACCEPT_PROPOSAL)
    && lastAgentMessage.actions?.includes(AiChatActionType.REJECT_PROPOSAL)
  ) {
    return lastAgentMessage;
  }

  return undefined;
};

export const isProposalDecisionPending = (session: ChatSession | null): boolean => {
  return !session?.requires_revised_invoice && getPendingProposalMessage(session) !== undefined;
};

export const isPendingProposalMessage = (session: ChatSession | null, messageId: number): boolean => {
  return !session?.requires_revised_invoice && getPendingProposalMessage(session)?.message_id === messageId;
};